import { StateMyInspections } from '@/store/state';
import makeSlicer from '@/utils/makeSlicer';

const rootSlicer = makeSlicer<StateMyInspections>();

export const inspections = rootSlicer('inspections');
export const loaded = rootSlicer('loaded');
